import { useApi } from '@backstage/core-plugin-api';
import { sev2ApiRef, UploadFileRequest, UploadFileResponse } from '@internal/backstage-plugin-sev2';
import { useCallback } from 'react';
import { useAsyncFn } from 'react-use';

export const useUploadFile = () => {
    const api = useApi(sev2ApiRef);

    const apiUploadFile = useCallback(
      async (params: UploadFileRequest) : Promise<UploadFileResponse> => {
        try {
          return await api.uploadFile(params);
        } catch (err: any) {
          return err;
        }
      },
      [api],
    );

    const [state, uploadFile] = useAsyncFn(
      (params: UploadFileRequest) => apiUploadFile(params),
      [apiUploadFile],
    );

    return {
      loading: state.loading,
      data: state?.value,
      error: state.error,
      uploadFile,
    };
};